import { MapLayer } from "@iventis/domain-model/model/mapLayer";
import { allowedStyleTypesForWhat3Words } from "./what3words-constants";

export const canLayerHaveWhat3WordsAttribute = (layer: MapLayer) => allowedStyleTypesForWhat3Words.includes(layer.styleType);
